import { Input, Component } from '@angular/core';

@Component({
  selector: 'error',
  template:
    `<h2>Error</h2>
    <span *ngIf="!errorMessage">
      <h3>The page you are looking for cannot be found.</h3>
      Please verify that the URL you used is correct<br>{{invalidUrl}}
    </span>
    <span *ngIf="errorMessage">{{errorMessage}}</span>`
})
export class ErrorComponent {
  @Input() public errorMessage:string;
  @Input() public invalidUrl:string;

  constructor() {
    /**/
  }
}